import React, { useMemo } from 'react';
import { useChainConfiguration } from '@occc-app/Chain/hooks';
import { NotFound } from '../routes/NotFound';

type ChainConfiguration = ReturnType<typeof useChainConfiguration>;

export type ChainGuardProps = {
  isFeatureEnabled: (chainConfig: ChainConfiguration) => boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

export const ChainGuard = ({ isFeatureEnabled, children, fallback }: ChainGuardProps) => {
  const chainConfiguration = useChainConfiguration();
  const shouldRender = useMemo(
    () => isFeatureEnabled(chainConfiguration),
    [isFeatureEnabled, chainConfiguration],
  );

  if (shouldRender) {
    return <>{children}</>;
  }

  return fallback ? <>{fallback}</> : <NotFound />;
};
